const ENDPOINT_BASE='/offers/';

export const getOfferUrl = (id) => {
    return ENDPOINT_BASE+id;
}

export const getSentOffersUrl = (id) => {
    return ENDPOINT_BASE+'all/sent/'+id;
}

export const getReceivedOffersUrl = (id) => {
    return ENDPOINT_BASE+'all/received/'+id;
}

export const getCreateOfferUrl = () => {
    return ENDPOINT_BASE;
}

export const getOfferPriceUrl = (id) => {
    return ENDPOINT_BASE+id+'/price';
}

export const getAcceptOfferUrl = (id) => {
    return ENDPOINT_BASE+id+'/accept';
}

export const getDeclineOfferUrl = (id) => {
    return ENDPOINT_BASE+id+'/decline';
}

export const getCancelOfferUrl = (id) => {
    return ENDPOINT_BASE+id;
}